<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            .submarine(ref='submarine')
                .submarine_img-wrp
                    img(src='../../assets/img/animated-scroll/submarine.svg')
            .submarine-mask
            

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    data() {
        return {
            isControlScroll: true
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'middle-middle');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.set(this.$refs.submarine, {y: '100%'}).fromTo(this.$refs.submarine, {y: '100%'}, {duration: 1, ease: 'none', y: '0'}, 1);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 60vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: static !important;
    height: auto;
    width: 100%;
    height: 60vh;
    background-color: var(--theme);
}
.submarine {
    position: absolute;
    bottom: 35%;
    left: 0;
    width: 100%;
    img {
        display: block;
    }
    &-mask {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 35%;
        width: 100%;
        background-color: var(--theme);
    }
    &_img-wrp {
        width: fit-content;
        margin: auto;
    }
}
</style>
